import { Card, Form, Input, Radio, Select, Button } from 'antd'
import React, { useEffect, useState } from 'react'
import withEditable from '../childComponents/editableInputsHOC/withEditable.component'
import TimeSelector from '../../Timpicker/timepicker'
import UploadImage from '../../uploadImage/uploadimage'
import dayjs from 'dayjs'
import { CUISINE_DROPDOWN_OPTIONS } from '../../../MetaData/cuisine.metadata'
import { DeleteOutlined } from '@ant-design/icons'

const EditableInput = withEditable(Input)
const EditableSelect = withEditable(Select)
const EditableRadioGroup = withEditable(Radio.Group)
const RestaurantComponent = ({ vendorDetails, updateVendorInfo }: any) => {
  const [workingDays, setWorkingDays] = useState<string[]>([])
  const [form] = Form.useForm()
  const cuisineOptions = CUISINE_DROPDOWN_OPTIONS
  const amenityOptions = [
    { label: 'Free WiFi', value: 'Free WiFi', selected: false, icon: 'wifi' },
    {
      label: 'Air Conditioning',
      value: 'Air Conditioning',
      selected: false,
      icon: 'ac_unit'
    },
    {
      label: 'Live Music',
      value: 'Live Music',
      selected: false,
      icon: 'music_note'
    },
    {
      label: 'Kids Play Area',
      value: 'Kids Play Area',
      selected: false,
      icon: 'child_care'
    },
    {
      label: 'Outdoor Seating',
      value: 'Outdoor Seating',
      selected: false,
      icon: 'outdoor_grill'
    },
    {
      label: 'CCTV Security',
      value: 'CCTV Security',
      selected: false,
      icon: 'security'
    },
    {
      label: 'Pet Friendly',
      value: 'Pet Friendly',
      selected: false,
      icon: 'pets'
    },
    {
      label: 'EV Charging',
      value: 'EV Charging',
      selected: false,
      icon: 'ev_station'
    },
    {
      label: 'Feeding Room',
      value: 'Feeding Room',
      selected: false,
      icon: 'child_friendly'
    },
    {
      label: 'Charging Point',
      value: 'Charging Point',
      selected: false,
      icon: 'power'
    },
    {
      label: 'Parking',
      value: 'Parking',
      selected: false,
      icon: 'local_parking'
    },
    { label: 'Washroom', value: 'Washroom', selected: false, icon: 'wash' }
  ]
  const formItems = [
    {
      name: 'restaurantId',
      label: 'Restaurant Id',
      type: 'input',
      initialValue: vendorDetails.restaurantId,
      options: [],
      hasHelp: false,
      helpOptions: [{ label: '', description: '' }],
      editable: false
    },
    {
      name: 'registeredStatus',
      label: 'Registered Status',
      type: 'input',
      initialValue: vendorDetails.registeredStatus,
      options: [],
      hasHelp: false,
      helpOptions: [{ label: '', description: '' }],
      editable: false
    },
    {
      name: 'restaurantName',
      label: 'Restaurant name',
      type: 'input',
      initialValue: vendorDetails.restaurantName,
      options: [],
      hasHelp: false,
      helpOptions: [{ label: '', description: '' }],
      editable: true
    },
    {
      name: 'restaurantAddress',
      label: 'Restaurant Address',
      type: 'input',
      initialValue: vendorDetails.restaurantAddress.address,
      options: [],
      hasHelp: false,
      helpOptions: [{ label: '', description: '' }],
      editable: true
    },
    {
      name: 'city',
      label: 'City',
      type: 'input',
      initialValue: vendorDetails.restaurantAddress.city,
      options: [],
      hasHelp: false,
      helpOptions: [{ label: '', description: '' }],
      editable: true
    },
    {
      name: 'pincode',
      label: 'Pincode',
      type: 'input',
      initialValue: vendorDetails.restaurantAddress.pincode,
      options: [],
      hasHelp: false,
      helpOptions: [{ label: '', description: '' }],
      editable: true
    },
    {
      name: 'priceForTwo',
      label: 'Price For Two',
      type: 'input',
      initialValue: vendorDetails.priceForTwo
        ? vendorDetails.priceForTwo.toString()
        : '',
      options: [],
      hasHelp: false,
      helpOptions: [{ label: '', description: '' }],
      editable: true
    },
    {
      name: 'cuisine',
      label: 'Cuisine',
      type: 'select',
      initialValue: vendorDetails.cuisine
        .filter((cuisine: { label: string; value: string }) =>
          cuisineOptions.find((option) => option.value === cuisine.value)
        )
        .map((cuisine: { label: string; value: string }) => cuisine.value),
      mode: 'multiple',
      options: cuisineOptions,
      editable: true,
      hasHelp: false,
      helpOptions: [
        {
          label: '',
          description: ''
        }
      ]
    },
    {
      name: 'amenities',
      label: 'Amenities',
      type: 'select',
      initialValue: vendorDetails.amenities
        ? vendorDetails.amenities
            .filter((amenity: any) => (amenity.selected ? true : false))
            .map((amenity: any) => amenity.value)
        : [],
      mode: 'multiple',
      options: amenityOptions,
      editable: true,
      hasHelp: false,
      helpOptions: [
        {
          label: '',
          description: ''
        }
      ]
    },
    {
      name: 'gstCategoryType',
      label: 'GST Category',
      type: 'select',
      initialValue: vendorDetails.gstCategoryType,
      options: [
        { label: 'Category 1', value: '1' },
        { label: 'Category 2', value: '2' },
        { label: 'Category 3', value: '3' }
      ],
      editable: true,
      hasHelp: true,
      helpOptions: [
        {
          label: 'Category 1',
          description:
            'Sells freshly prepared food items only. Does not sell any packed item',
          footer: 'Foodtolls will pay GST on your behalf'
        },
        {
          label: 'Category 2',
          description:
            'Sells IceCreams,bakery products,sweets or other packed items only',
          footer: 'The outlet itself will pay GST on these orders'
        },
        {
          label: 'Category 3',
          description: 'Sells both freshly prepared and packaged food items',
          footer:
            'Foodtolls will pay GST on sales of freshly prepared food items'
        }
      ]
    },
    {
      name: 'serviceType',
      label: 'Service Category',
      type: 'select',
      initialValue: vendorDetails.serviceType,
      options: [
        { label: 'Service 1', value: '1' },
        { label: 'Service 2', value: '2' },
        { label: 'Service 3', value: '3' },
        { label: 'Service 4', value: '4' },
        { label: 'Service 5', value: '5' }
      ],
      editable: true,
      hasHelp: true,
      helpOptions: [
        {
          label: 'Service 1',
          description:
            'Only Indoor dining service. No outdoor and TakeAway options',
          footer:
            'Foodtolls will not collect any parcel charges for the food items'
        },
        {
          label: 'Service 2',
          description: 'Outdoor dining service. No Indoor and TakeAway options',
          footer:
            'Foodtolls will not collect any parcel charges for the food items'
        },
        {
          label: 'Service 3',
          description: 'Indoor & outdoor dining service. No TakeAway options',
          footer:
            'Foodtolls will not collect any parcel charges for the food items'
        },
        {
          label: 'Service 4',
          description: 'Indoor, outdoor dining & takeaway  service.',
          footer:
            'Foodtolls will collect  parcel charges for the food items on food items eligible for take away'
        },
        {
          label: 'Service 5',
          description: 'Only takeaway  service.',
          footer:
            'Foodtolls will collect  parcel charges for the food items on food items eligible for take away'
        },
        {
          label: 'Service 6',
          description: 'Indoor & takeaway  service. No outdoor dining',
          footer:
            'Foodtolls will collect  parcel charges for the food items on food items eligible for take away'
        },
        {
          label: 'Service 7',
          description: 'Outdoor & takeaway  service. No indoor dining',
          footer:
            'Foodtolls will collect  parcel charges for the food items on food items eligible for take away'
        }
      ]
    },
    {
      name: 'pureVeg',
      label: 'Pure Veg',
      type: 'radio',
      initialValue: vendorDetails.pureVeg || false,
      options: [
        { label: 'Yes', value: true },
        { label: 'No', value: false }
      ],
      editable: true,
      hasHelp: false,
      helpOptions: [{ label: '', description: '' }]
    },
    {
      name: 'maxHeadCountPerOrder',
      label: 'Max Head Count Per Order',
      type: 'input',
      inputType: 'number',
      min: 1,
      max: 100,
      initialValue: vendorDetails.maxHeadCountPerOrder?.toString() || '10',
      options: [],
      hasHelp: false,
      helpOptions: [{ label: '', description: '' }],
      editable: true
    }
  ]

  const inputChange = (value: any, item: any) => {
    form.setFieldsValue({ [item.name]: value })
    if (
      item.name === 'restaurantAddress' ||
      item.name === 'city' ||
      item.name === 'pincode'
    ) {
      vendorDetails['restaurantAddress'][
        item.name === 'restaurantAddress' ? 'address' : item.name
      ] = value
    } else if (item.name === 'amenities') {
      vendorDetails[item.name] = amenityOptions.map((amenity) =>
        value.includes(amenity.value)
          ? { ...amenity, selected: true }
          : { ...amenity, selected: false }
      )
    } else if (item.name === 'maxHeadCountPerOrder') {
      vendorDetails[item.name] = parseInt(value, 10) || 10
    } else {
      vendorDetails[item.name] = value
    }
    updateVendorInfo(vendorDetails)
  }

  const selectionDayChange = (value: any, name: any) => {
    console.log(value, name)
    Object.keys(vendorDetails[name]).forEach((day) => {
      if (value.includes(day)) {
        vendorDetails[name][day].restaurantOpen = 'Open'
      } else {
        vendorDetails[name][day].restaurantOpen = 'Close'
        vendorDetails[name][day].workingHours.open = '00:00'
        vendorDetails[name][day].workingHours.close = '00:00'
      }
    })
    updateVendorInfo(vendorDetails)
  }

  const selectionTimeChange = (value: any, day: any) => {
    const updatedVendorDetails = structuredClone(vendorDetails)
    updatedVendorDetails['workingDaysAndHours'][day]['workingHours']['open'] =
      dayjs(value[0]).format('hh:mm:ss A')
    updatedVendorDetails['workingDaysAndHours'][day]['workingHours']['close'] =
      dayjs(value[1]).format('hh:mm:ss A')
    updateVendorInfo(updatedVendorDetails)
  }

  const onImageUpload = (images: any, imageType: any) => {
    console.log(images, imageType)
    vendorDetails['imageCategory'][imageType] = images
    updateVendorInfo(vendorDetails)
  }

  const selectionRushTimeChange = (value: any, day: any, index: number) => {
    const updatedVendorDetails = structuredClone(vendorDetails)
    if (!updatedVendorDetails['workingDaysAndHours'][day]['rushHours']) {
      updatedVendorDetails['workingDaysAndHours'][day]['rushHours'] = []
    }

    if (!value || !value[0] || !value[1]) {
      updatedVendorDetails['workingDaysAndHours'][day]['rushHours'][index] = {
        startTime: '',
        endTime: ''
      }
    } else {
      updatedVendorDetails['workingDaysAndHours'][day]['rushHours'][index] = {
        startTime: dayjs(value[0]).format('hh:mm:ss A'),
        endTime: dayjs(value[1]).format('hh:mm:ss A')
      }
    }
    updateVendorInfo(updatedVendorDetails)
  }

  const addRushHour = (day: string) => {
    const updatedVendorDetails = structuredClone(vendorDetails)
    if (!updatedVendorDetails['workingDaysAndHours'][day]['rushHours']) {
      updatedVendorDetails['workingDaysAndHours'][day]['rushHours'] = []
    }
    updatedVendorDetails['workingDaysAndHours'][day]['rushHours'].push({
      startTime: '',
      endTime: ''
    })
    updateVendorInfo(updatedVendorDetails)
  }

  const removeRushHour = (day: string, index: number) => {
    const updatedVendorDetails = structuredClone(vendorDetails)
    if (updatedVendorDetails['workingDaysAndHours'][day]['rushHours']) {
      updatedVendorDetails['workingDaysAndHours'][day]['rushHours'].splice(
        index,
        1
      )
    }
    updateVendorInfo(updatedVendorDetails)
  }

  const validateRushHours = (value: any, day: string) => {
    if (!value || !value[0] || !value[1]) {
      return Promise.resolve()
    }

    const openTimeStr =
      vendorDetails.workingDaysAndHours[day]?.workingHours?.open
    const closeTimeStr =
      vendorDetails.workingDaysAndHours[day]?.workingHours?.close

    if (
      !openTimeStr ||
      !closeTimeStr ||
      openTimeStr === '00:00' ||
      closeTimeStr === '00:00' ||
      openTimeStr === 'Invalid Date' ||
      closeTimeStr === 'Invalid Date'
    ) {
      return Promise.reject(
        new Error(`Please set working hours for ${day} first`)
      )
    }

    const openTime = dayjs(openTimeStr, 'hh:mm:ss A')
    let closeTime = dayjs(closeTimeStr, 'hh:mm:ss A')

    if (closeTime.isBefore(openTime) || closeTime.isSame(openTime)) {
      closeTime = closeTime.add(1, 'day')
    }

    const rushStartStr = dayjs(value[0]).format('hh:mm:ss A')
    const rushEndStr = dayjs(value[1]).format('hh:mm:ss A')

    let rushStart = dayjs(rushStartStr, 'hh:mm:ss A')
    let rushEnd = dayjs(rushEndStr, 'hh:mm:ss A')

    if (rushStart.isBefore(openTime)) {
      rushStart = rushStart.add(1, 'day')
    }

    if (rushEnd.isBefore(rushStart) || rushEnd.isBefore(openTime)) {
      rushEnd = rushEnd.add(1, 'day')
    }

    if (rushStart.isBefore(openTime) || rushStart.isAfter(closeTime)) {
      return Promise.reject(
        new Error(
          `Rush hour start must be between ${openTimeStr} and ${closeTimeStr}`
        )
      )
    }
    if (rushEnd.isBefore(openTime) || rushEnd.isAfter(closeTime)) {
      return Promise.reject(
        new Error(
          `Rush hour end must be between ${openTimeStr} and ${closeTimeStr}`
        )
      )
    }

    return Promise.resolve()
  }

  useEffect(() => {
    const allWorkingDays = Object.keys(vendorDetails.workingDaysAndHours)
    const reqDays = allWorkingDays.filter(
      (day) => vendorDetails.workingDaysAndHours[day].restaurantOpen === 'Open'
    )
    form.setFieldValue('availableDays', reqDays)
    setWorkingDays(reqDays)
  }, [vendorDetails])
  // Simulate API call
  const handleApiCall = (name: string, value: any) => {
    console.log(`API call for ${name}:`, value)
  }
  return (
    <Card
      title={<h2>Restaurant Details</h2>}
      style={{
        padding: '20px'
      }}
    >
      <div className='profile_flex'>
        <Form
          form={form}
          layout='vertical'
          initialValues={Object.fromEntries(
            formItems.map((item) => [item.name, item.initialValue])
          )}
        >
          <div className="profile-form-grid">
            {formItems.map((item) => (
              <Form.Item key={item.name} name={item.name} label={item.label}>
                {item.type === 'input' && (
                  <EditableInput
                    type={item.inputType || 'text'}
                    min={item.min}
                    max={item.max}
                    value={form.getFieldValue(item.name)}
                    onChange={(value) => inputChange(value, item)}
                    onSubmit={(value) => handleApiCall(item.name, value)}
                    disabled={false}
                    editable={item.editable}
                    hasHelp={item.hasHelp}
                    helpOptions={item.helpOptions}
                  />
                )}
                {item.type === 'select' && (
                  <EditableSelect
                    mode={item.mode as 'multiple' | 'tags' | undefined}
                    value={form.getFieldValue(item.name)}
                    onChange={(value) => inputChange(value, item)}
                    onSubmit={(value) => handleApiCall(item.name, value)}
                    disabled={false}
                    options={item.options}
                    editable={item.editable}
                    hasHelp={item.hasHelp}
                    helpOptions={item.helpOptions}
                  ></EditableSelect>
                )}
                {item.type === 'radio' && (
                  <EditableRadioGroup
                    value={form.getFieldValue(item.name)}
                    onChange={(value) => inputChange(value, item)}
                    onSubmit={(value) => handleApiCall(item.name, value)}
                    disabled={false}
                    options={item.options}
                    editable={item.editable}
                    hasHelp={item.hasHelp}
                    helpOptions={item.helpOptions}
                  ></EditableRadioGroup>
                )}
              </Form.Item>
            ))}
          </div>
          <div className='availability'>
            <h2> Restaurant Features</h2>
            <div className='workingHours_class'>
              <Form.Item
                label='AvailableDays'
                style={{ fontSize: 20, width: '300px' }}
                name='availableDays'
                rules={[
                  {
                    required: true,
                    message: 'Selec atleast 1 availbale day'
                  }
                ]}
              >
                <Select
                  mode='multiple'
                  allowClear
                  style={{ width: '100%' }}
                  placeholder='Please select'
                  // defaultValue={foodItemList.availableDays}
                  options={Object.keys(vendorDetails.workingDaysAndHours).map(
                    (key: string) => ({
                      value: key,
                      label: key
                    })
                  )}
                  onChange={(e) => selectionDayChange(e, 'workingDaysAndHours')}
                />
              </Form.Item>
            </div>
            <h2> Working Days/Time</h2>
            <h2>Open Time</h2>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '50px' }}>
              {workingDays?.map((availableDay: string) => {
                return (
                  <TimeSelector
                    key={availableDay}
                    initialValue={Object.keys(vendorDetails.workingDaysAndHours)
                      .filter((day: string) => day === availableDay)
                      .flatMap((reqDay: string) => {
                        return [
                          vendorDetails.workingDaysAndHours[reqDay].workingHours
                            .open,
                          vendorDetails.workingDaysAndHours[reqDay].workingHours
                            .close
                        ]
                      })}
                    label={`${availableDay} start and end time`}
                    controlName={availableDay}
                    validators={[
                      {
                        required: true,
                        message: `PLease select open and close time for ${availableDay}`
                      }
                    ]}
                    avalialbleHours={vendorDetails.workingDaysAndHours}
                    onTimeChange={(e: any) =>
                      selectionTimeChange(e, availableDay)
                    }
                  />
                )
              })}
            </div>
            <h2>Rush Hours</h2>
            <div
              style={{ display: 'flex', flexDirection: 'column', gap: '30px' }}
            >
              {workingDays?.map((availableDay: string) => {
                const rushHours =
                  vendorDetails.workingDaysAndHours[availableDay]?.rushHours ||
                  []

                return (
                  <div
                    key={`${availableDay}-rush-container`}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '10px'
                    }}
                  >
                    <h3 style={{ margin: 0 }}>{availableDay}</h3>
                    {rushHours.map((rushHour: any, index: number) => {
                      const initialRushValues =
                        rushHour.startTime && rushHour.endTime
                          ? [rushHour.startTime, rushHour.endTime]
                          : ['', '']

                      return (
                        <div
                          key={`${availableDay}-rush-${index}`}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px'
                          }}
                        >
                          <TimeSelector
                            initialValue={initialRushValues}
                            label={`Rush Hour ${index + 1}`}
                            controlName={`${availableDay}-rush-${index}`}
                            validators={[
                              {
                                validator: (_: any, value: any) =>
                                  validateRushHours(value, availableDay)
                              }
                            ]}
                            onTimeChange={(e: any) =>
                              selectionRushTimeChange(e, availableDay, index)
                            }
                          />
                          <Button
                            type='dashed'
                            danger
                            onClick={() => removeRushHour(availableDay, index)}
                            // style={{ marginBottom: '24px' }}
                          >
                            Remove <DeleteOutlined />
                          </Button>
                        </div>
                      )
                    })}
                    <Button
                      type='dashed'
                      onClick={() => addRushHour(availableDay)}
                      style={{ alignSelf: 'flex-start' }}
                    >
                      + Add Rush Hour
                    </Button>
                  </div>
                )
              })}
            </div>
            <h2>Restaurant Images</h2>
            <div className='photo'>
              <h2>Photos</h2>
              {Object.keys(vendorDetails.imageCategory).map((imageType) => {
                return (
                  <div key={imageType}>
                    <h3 style={{ textTransform: 'capitalize' }}>{imageType}</h3>
                    <div className='image_container'>
                      <UploadImage
                        images={vendorDetails.imageCategory[imageType]}
                        fileType={`${vendorDetails.restaurantId}/RestaurantImages`}
                        imageType={imageType}
                        onImageUpload={(e: any) => onImageUpload(e, imageType)}
                      />
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        </Form>
      </div>
    </Card>
  )
}

export default RestaurantComponent
